import {IHeaderParams} from 'ag-grid-community';
import {InventoryQualityTableColumns} from '../components/sites-table/types';

export type ColoredChip = {
    backgroundColor: string;
    color: string;
    borderColor: string;
    text: string;
    opacity? : number;
}

export enum PolarisRoutePaths {
    POLARIS_HOME = 'home',
    MARKET_INTEL = 'market-intel',
    CHAT = 'c',
    SHARED = 'shared',
    ALERTS = 'alerts'
}

export enum AlertsRoutePaths {
    ALERT_HOME = 'home',
    ALERT_VIEW = 'a'
}

export enum RoutePaths {
    EMPTY = '',
    TRIAL = 'signup',
    MY_BRAND = 'my-brand',
    SIGNALS = 'signals',
    DATA_POINTS = 'data-points',
    MANAGE = 'manage',
    BRANDS = 'brands',
    USERS = 'users',
    ACCOUNTS = 'accounts',
    COMPETITION = 'my-competition',
    CAMPAIGNS = 'my-campaigns',
    POLARIS = 'polaris',
    AUDIENCE = 'audience',
    AI_PRESENCE = 'ai-presence',
    REPUTATION = 'reputation',
    SOCIAL_OVERVIEW = 'social-overview',
    MESSAGING = 'messaging',
    WORKSPACE_ERROR = 'workspace-error',
    ALERT_CENTER = `polaris/${PolarisRoutePaths.ALERTS}/${AlertsRoutePaths.ALERT_HOME}`,
    ALERT_VIEW = `polaris/${PolarisRoutePaths.ALERTS}/${AlertsRoutePaths.ALERT_VIEW}`,
    SOCIAL = 'social'
}

export enum TrialStep {
    REGISTER_EMAIL = 1,
    SELECT_BRAND = 2,
    PROFILE = 3,
    COMPLETE = 4
}

export enum MessagingRoutePaths {
    MARKETING_REPORT = 'marketing-report',
    CREATIVE_GALLERY = 'creative-gallery'
}

export enum SocialRoutePaths {
    OVERVIEW = 'overview'
}

export enum FormMode {
    ADD = 'add',
    EDIT = 'edit'
}

export type WidgetValueField = '' | 'share' | 'score' | 'value'
export interface BaseChartData {
    name?: string;
    key?: string;
    y?: any;
    date?: string;
}

export type ChartData = BaseChartData & {
    [K in WidgetValueField]?: number;
};
export interface TableHeaderParams extends IHeaderParams{
  tooltip?: string;
  sortable?: boolean;
  field?: InventoryQualityTableColumns;
}

export enum BrandColors {
    MY_BRAND = "#840456",
    BRAND_1 = "#04857E",
    BRAND_2 = "#FF8039",
    BRAND_3 = "#999FCC",
    BRAND_4 = "#FFCC66",
    BRAND_5 = "#9FB264",
    BRAND_6 = "#F6CDBA",
    BRAND_7 = "#2661BF",
    BRAND_8 = "#D45B93",
    BRAND_9 = "#9C7F63",
    BRAND_10 = "#084D4C"
};

export enum BrandLineColors {
    MY_BRAND = "#6E0348",
    BRAND_1 = "#036F69",
    BRAND_2 = "#EB6117",
    BRAND_3 = "#8C90B8",
    BRAND_4 = "#EDBE58",
    BRAND_5 = "#94A65E",
    BRAND_6 = "#F1B498",
    BRAND_7 = "#2661BF",
    BRAND_8 = "#B84F80",
    BRAND_9 = "#826A53",
    BRAND_10 = "#073D3D"
}

export const WIDGET_COLOR_SCALE = [
    BrandColors.BRAND_1, 
    BrandColors.BRAND_2, 
    BrandColors.BRAND_3, 
    BrandColors.BRAND_4, 
    BrandColors.BRAND_5, 
    BrandColors.BRAND_6, 
    BrandColors.BRAND_7, 
    BrandColors.BRAND_8,
];

export const WIDGET_LINE_COLOR_SCALE = [
    BrandLineColors.BRAND_1,
    BrandLineColors.BRAND_2,
    BrandLineColors.BRAND_3,
    BrandLineColors.BRAND_4,
    BrandLineColors.BRAND_5,
];

export const MY_BRAND_COLOR = BrandColors.MY_BRAND;

export const ATTENTION_METRIC_NAME = 'TruAttention™';
